<script setup lang="ts">
const props = defineProps<{
  class?: string,
  fixed?: boolean,
}>();
</script>

<template>
  <div :class="[props.class, 'fixed-safe-area', { fixed }]">
    <slot />
  </div>
</template>

<style scoped>
.fixed-safe-area {
  padding: var(--ion-safe-area-top) var(--ion-safe-area-right) var(--ion-safe-area-bottom) var(--ion-safe-area-left);
}

.fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
